/**
 * Remember the Amanda conversation this browser was last using, so a page
 * reload or an auto-send trigger ("Create with AI") continues it instead of
 * starting a fresh one. Prod audit 2026-09-17: one user opened four
 * conversations in seven minutes because every trigger reset the id, and
 * each restart lost the draft Amanda had just created.
 *
 * localStorage is a per-viewer convenience: every read and write is guarded.
 */
const KEY = "sf_amanda_conv";
export const CONVERSATION_REUSE_MS = 30 * 60_000;

export function rememberConversation(id: string, at: number = Date.now()): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ id, at }));
  } catch {
    /* storage unavailable */
  }
}

export function recallConversation(now: number = Date.now()): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { id, at } = JSON.parse(raw) as { id?: string; at?: number };
    if (!id || typeof at !== "number") return null;
    return now - at <= CONVERSATION_REUSE_MS ? id : null;
  } catch {
    return null;
  }
}

export function forgetConversation(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
